// extracted by mini-css-extract-plugin
export var bold = "_sd-0";